import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useEnterGiveawayButton } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useEnterGiveawayButton';
import { useGiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { memo } from 'react';
export const EnterGiveawayButton = memo(() => {
    const { onEnterGiveaway, isLoading } = useEnterGiveawayButton();
    const { isPickingWinner, isWaitTimeExpired } = useGiveawaySection();
    const isEnabled = !isPickingWinner && !isWaitTimeExpired;
    return (<ButtonNew type="button" onClick={() => onEnterGiveaway()} disabled={!isEnabled} className="min-h-12 min-w-52 flex-initial items-center justify-center">
			{isLoading ? (<LoadingCircles className="flex-initial" width={26} height={26}/>) : (<span className="enter-giveaway uppercase font-bold">
					Enter giveaway
				</span>)}
		</ButtonNew>);
});
